/*
 * @Author: 1544807500@qq.com
 * @Date: 2025-05-29 14:27
 * @LastEditors: 1544807500@qq.com
 * @LastEditTime: 2025-06-23 14:36
 * @FilePath: \glyun_web_Vue3\src\router\other.js
 * @Description: 其他路由
 */
export default [
  {
    path: '/other',
    redirect: '/other/cardOpeningList',
    name: 'other',
    component: () => import('../views/nav/index.vue'),
    children: [
      {//开卡名单管理
        path: 'cardOpeningList',
        name: 'otherCardOpeningList',
        component: () => import('../views/other/cardOpeningList/index.vue'),
        meta: {
          title: 'v2_card_opening_list_management',
          routeAuthCode: 'A0800'
        }
      },
      {//项目公司管理
        path: 'projectCompany',
        name: 'otherProjectCompany',
        component: () => import('../views/other/projectCompany/index.vue'),
        meta: {
          title: 'v2_project_company_management',
          routeAuthCode: 'A0801',
        }
      },
      {//录入员账号管理
        path: 'entryClerkAccount',
        name: 'otherEntryClerkAccount',
        component: () => import('../views/other/entryClerkAccount/index.vue'),
        meta: {
          title: 'v2_recorder_account_management',
          routeAuthCode: 'A0802',
        }
      },
      {//NMI控制
        path: 'nmiControl',
        name: 'otherNmiControl',
        component: () => import('../views/other/nmiControl/index.vue'),
        meta: {
          title: 'v2_sapn_NmiControl',
          routeAuthCode: 'A0803',
        }
      },
    ],
  },
]